import React, { useState, useEffect } from "react";
import { Typography, Grid, Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import EditIcon from "@material-ui/icons/Edit";
import BiztranControls from "../../biztran_controls/BiztranControls";
import UseFetchData from "../../../hooks/UseFetchData";
import ModalFrame from "../../biztran_controls/Modal_Frame";
import CreateProduct from "./CreateProduct";

const ViewHeader = (props) => {
    const classes = useStyles();
    const [ProductName, setProductName] = useState("");
    const [ProductType, setProductType] = useState("");
    const [ProductGroup, setProductGroup] = useState("");
    const [Make, setMake] = useState("");
    const [ShortDescription, setShortDescription] = useState("");
    const [LongDescription, setLongDescription] = useState("");
    const [Mode, setMode] = useState("");
    const [isOpen, setOpen] = useState(false);
    const [responsePop, fetchDataPop] = UseFetchData();
  
    const PopulateData = () => {
      var bodyFormData = new FormData();
      bodyFormData.append("ProductName", "");
      bodyFormData.append("ProductType", "");
      bodyFormData.append("Description", "");
      bodyFormData.append("ProductGroup", "");
      fetchDataPop("product/List", bodyFormData);
    };
  
    const handleOpenModel = () => {
      setMode("Update");
      setOpen(true);
    };
  
    const handleOpenNewModel = () => {
      setMode("Insert");
      setOpen(true);
    };
  
    useEffect(() => {
        if (props.responseGetByID !== undefined && props.responseGetByID.length > 0) {
            setProductName(props.responseGetByID[0].ProductName);
            setProductType(props.responseGetByID[0].ProductType);
            setProductGroup(props.responseGetByID[0].ProductGroup);
            setMake(props.responseGetByID[0].Make);
            setShortDescription(props.responseGetByID[0].ShortDescription);
            setLongDescription(props.responseGetByID[0].LongDescription);
        }
    }, [props.responseGetByID]);

    return(
            <Paper elevation={3} >
                <Typography className={classes.headertext} noWrap >
                    <h4 style={{ fontSize: 25 }}>Product Master</h4>
                    <div style={{ width: "100%" }}>
                        <div style={{ float: "right", marginTop: -3 }}>
                            {/* <BiztranControls.Button
                                text="ADD NEW"
                                startIcon={<AddCircleOutlineIcon />}
                                onClick={() => {
                                    handleOpenNewModel();
                                }}
                            /> */}
                            <BiztranControls.Button
                                text="EDIT"
                                startIcon={<EditIcon />}
                                onClick={() => {
                                    handleOpenModel();
                                }}
                            /> 
                        </div>
                    </div>
                </Typography>
                <Grid spacing={1} container style={{ marginLeft: 3 }}>
                    <Grid item xs={12} container direction="row">
                        <Grid item xs={4} container direction="row">
                            <h5 style={{ color: "#808080", width:100 }}>Product Details:</h5>
                            <h5 style={{ color: "#0096FF" }}>{ProductName}</h5>
                        </Grid>
                        <Grid item xs={4} container direction="row">
                            <h5 style={{ color: "#808080", width:90 }}>Product Group:</h5>
                            <h5 style={{ color: "#0096FF" }}>{ProductGroup}</h5>
                        </Grid>
                        <Grid item xs={4} container direction="row">
                            <h5 style={{ color: "#808080", width:110 }}>Short Description:</h5>
                            <h5 style={{ color: "#0096FF" }}>{ShortDescription}</h5>
                        </Grid>
                        </Grid>
                        <Grid item xs={12} container direction="row">
                        <Grid item xs={4} container direction="row">
                            <h5 style={{ color: "#808080", width:100 }}>Product Type:</h5>
                            <h5 style={{ color: "#0096FF" }}>{ProductType}</h5>
                        </Grid>
                        <Grid item xs={4} container direction="row">
                            <h5 style={{ color: "#808080", width:90 }}>Make:</h5>
                            <h5 style={{ color: "#0096FF" }}>{Make}</h5>
                        </Grid>
                        <Grid item xs={4} container direction="row">
                            <h5 style={{ color: "#808080", width:110 }}>Long Description:</h5>
                            <h5 style={{ color: "#0096FF" }}>{LongDescription}</h5>
                        </Grid>
                    </Grid>
                </Grid>
            <ModalFrame
                title="Product Details"
                maxWidth="sm"
                headerAlign="center"
                isOpen={isOpen}
                setOpen={setOpen}
            >
                <CreateProduct
                ProductID={props.ProductID}
                Mode={Mode}
                setOpen={setOpen}
                PopulateData={PopulateData}
                />
            </ModalFrame>
        </Paper>
    )
};

const useStyles = makeStyles((theme) => ({
  headertext: {
    background: "#e6d8d8", //theme.palette.tertiary.gradient,
    color: "#3d3d3d",
    height: "2.7rem",
    fontSize: "1.8rem",
    marginTop: "4.3rem",
    display: "flex",
    flexDirection: "row",
  },
}));

export default ViewHeader;
